<template>
  <pt-active-sign-detail class="pt-active-sign-detail__page" :id="id" :signId="signId"></pt-active-sign-detail>
</template>

<script>
import PtActiveSignDetail from 'cps/appointment-application/pt-active-sign/pt-active-sign-detail/withData'
export default {
  name: 'pt-active-sign-detail__view',
  components: {
    'pt-active-sign-detail': PtActiveSignDetail
  },
  props: {
    id: {
      type: String,
      default: null
    },
    signId: {
      type: String
    }
  }
}
</script>
